import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useOnlineStatus from '../hooks/useOnlineStatus';

export default function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  // Reset dismissed when coming back online so it shows again on next disconnect
  useEffect(() => {
    if (isOnline) setDismissed(false);
  }, [isOnline]);

  if (isOnline || dismissed) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10001,
        background: 'var(--orange-dark)',
        color: '#ffffff',
        padding: '0.5rem 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        fontFamily: 'var(--font-heading)',
        fontSize: '0.85rem',
        fontWeight: 600,
        letterSpacing: '0.05em',
        borderBottom: '1px solid var(--border)',
      }}
    >
      <span>{t('common.offlineMessage')}</span>
      <button
        onClick={() => setDismissed(true)}
        style={{
          background: 'rgba(255,255,255,0.2)',
          border: '1px solid rgba(255,255,255,0.3)',
          color: '#fff',
          padding: '0.2rem 0.6rem',
          borderRadius: 'var(--radius-sm)',
          cursor: 'pointer',
          fontSize: '0.75rem',
        }}
        aria-label={t('common.close')}
      >
        ✕
      </button>
    </div>
  );
}
